import PrivacyBanner from './PrivacyBanner';

export default PrivacyBanner;
